import { render, staticRenderFns } from "./rejectModal.vue?vue&type=template&id=ec80ea14"
import script from "./rejectModal.vue?vue&type=script&lang=js"
export * from "./rejectModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports